import * as yup from "yup";

// Reusable email validation schema
export const emailValidation = yup
  .string()
  .required("Email is required!")
  .transform((value) => value && typeof value === 'string' ? value.trim() : value)
  .email("Please enter a valid email")
  .test(
    "no-consecutive-dots",
    "Email cannot contain consecutive dots. Please enter a valid email.",
    (value) => !value || !/\.\./.test(value)
  )
  .test(
    "no-leading-trailing-dots",
    "Email cannot start or end with a dot. Please enter a valid email.",
    (value) => {
      if (!value) return true;
      
      // Extract local part (before @)
      const atIndex = value.lastIndexOf('@');
      if (atIndex === -1) return true; // Let email() validation handle this
      
      const localPart = value.substring(0, atIndex);
      
      // Check if local part starts or ends with a dot
      return !localPart.startsWith('.') && !localPart.endsWith('.');
    }
  )
  .test(
    "domain-has-dot-or-ip",
    "Please enter an email with a valid domain extension.",
    (value) => {
      if (!value) return true;
      
      // Extract domain part after @
      const atIndex = value.lastIndexOf('@');
      if (atIndex === -1) return true; // Let email() validation handle this
      
      const domain = value.substring(atIndex + 1);
      
      // Check if it's an IP address (allow IP addresses)
      const ipPattern = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
      if (ipPattern.test(domain)) return true;
      
      // For non-IP domains, require at least one dot (reject aa@aa, user@localhost, etc.)
      return domain.includes('.');
    }
  );
